import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clientService } from "../../../services";

import trade9Logo from "../../../template/images/Trade909logo.png";

const EmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [responseMessage, setResponseMessage] = useState({
    showBtn: true,
    message: "",
  });

  const { search, pathname } = useLocation();

  const hasRun = useRef(false); // Ref to ensure handleUpdate only runs once

  // Function to validate if the URL path and token query are correct
  const isValidPath = () => {
    const isEmailVerifiedPath = pathname.startsWith("/emailVerified/");
    const hasToken = search.includes("?token=");
    return isEmailVerifiedPath && hasToken;
  };

  useEffect(() => {
    if (isValidPath() && !hasRun.current) {
      hasRun.current = true; // Mark as run
      handleUpdate();
    }
  }, [search]);

  const handleUpdate = async () => {
    setIsLoading(true);
    setError(null); // Reset error

    try {
      let postClient;

      // Example of the clientService call to update client details
      postClient = await clientService.updateLeadInfo(
        search.split("?token=")[1]
      );

      // If message indicates the link is expired, handle accordingly
      if (postClient?.status === 202) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else if (postClient?.status === 201) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else {
        setIsLinkExpired(false);
        setResponseMessage({
          showBtn: true,
          message: postClient?.data?.message,
        });
      }
    } catch (err) {
      console.error("Error during verification:", err);
      setError(
        "There was an error verifying your email. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // If the URL path is not valid, show "Page Not Found"
  if (!isValidPath()) {
    return (
      <div
        style={{
          backgroundColor: "rgba(8, 15, 21, 0.6)",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "40px",
            borderRadius: "8px",
            maxWidth: "600px",
            width: "100%",
            textAlign: "center",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2 style={{ color: "red" }}>Page Not Found</h2>
          <p>
            The page you are looking for does not exist or the link is invalid.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "rgba(8, 15, 21, 0.6)",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "8px",
          maxWidth: "600px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Logo at the top */}
        <div style={{ marginBottom: "30px" }}>
          <img
            src={trade9Logo}
            alt="Trade9"
            style={{
              height: 48,
              maxWidth: 220,
              objectFit: "contain",
            }}
          />
        </div>

        {isLoading ? (
          <div style={{ fontSize: "16px", color: "#555" }}>
            <div className="loader"></div> {/* The loader */}
            <p style={{ marginTop: "10px" }}>
              Please wait while we complete the verification...
            </p>
          </div>
        ) : error ? (
          <p style={{ fontSize: "16px", color: "red" }}>{error}</p>
        ) : isLinkExpired ? (
          <div>
            <p style={{ fontSize: "16px", color: "red" }}>
              {responseMessage.message}
            </p>
          </div>
        ) : (
          <div style={{ fontSize: "16px", color: "#555" }}>
            <h5 className="text-bold">🎉 You're All Set! 🎉</h5>
            <h4 className="text-bold">✅ Account Verified Successfully!</h4>
            <p>{responseMessage.message}</p>
            <p>
              🚀 Get ready to{" "}
              <b>
                trade with raw spreads, lightning-fast execution, and top-tier
                tools!
              </b>
            </p>
            <p>
              If you don’t see the email soon, check your{" "}
              <b>spam or junk folder</b> just in case.
            </p>
            <p>
              💡 <b>Need help?</b> Contact us anytime!
            </p>
            <p>
              📩 Email: <a href="mailto:cs@godocm.com">trade@909.com</a>
            </p>
            <p className="text-bold">
              ✨ Welcome to the Trade-9 family—let’s trade smart!
            </p>
          </div>
        )}

        {/* Conditionally render the Login Button or Expired message */}
        {!isLinkExpired && !isLoading && !error && responseMessage.showBtn && (
          <div style={{ marginTop: "30px" }}>
            <a
              href="https://login.trade909.com/login/" // Update with your portal URL
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: "#000",
                color: "#A0E000",
                padding: "12px 30px",
                textDecoration: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Login to Client Portal
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
